export const rankingData = [
  {
    id: 1,
    rank: 1,
    title: "某顶流男星深夜密会神秘女子，酒店共度八小时",
    category: "明星情感",
    heat: "982万",
    trend: "up",
    tag: "今日爆",
  },
  {
    id: 2,
    rank: 2,
    title: "知名女星疑似婚变内幕曝光，双方已分居半年",
    category: "婚姻八卦",
    heat: "876万",
    trend: "up",
    tag: "新料",
  },
  {
    id: 3,
    rank: 3,
    title: "综艺节目录制现场冲突完整视频流出，导演组紧急叫停",
    category: "综艺内幕",
    heat: "754万",
    trend: "up",
    tag: "热",
  },
  {
    id: 4,
    rank: 4,
    title: "某大导新片选角黑幕被业内人士实名爆料",
    category: "影视黑料",
    heat: "689万",
    trend: "up",
    tag: "独家",
  },
  {
    id: 5,
    rank: 5,
    title: "昔日姐妹花反目成仇始末：从闺蜜到对簿公堂",
    category: "明星恩怨",
    heat: "621万",
    trend: "stable",
    tag: "深扒",
  },
  {
    id: 6,
    rank: 6,
    title: "某国际品牌代言人塌房事件完整时间线追踪",
    category: "代言风波",
    heat: "587万",
    trend: "up",
    tag: "追踪",
  },
  {
    id: 7,
    rank: 7,
    title: "选秀节目票数造假实锤证据曝光，主办方沉默应对",
    category: "选秀黑幕",
    heat: "543万",
    trend: "up",
    tag: "实锤",
  },
];

export const aboutData = {
  title: "关于51吃瓜网",
  description:
    "51吃瓜网入口是国内领先的娱乐资讯聚合平台，致力于为吃瓜群众提供最新、最全、最热的爆料内容。我们汇集全网优质吃瓜资源，覆盖明星八卦、综艺内幕、影视黑料、网红塌房等多个领域，每日更新海量一手资讯。平台以「快、准、全」为核心运营理念，专业编辑团队7×24小时追踪娱乐圈动态，确保用户不错过任何一条热门爆料。51吃瓜网入口不仅是吃瓜爱好者的信息集散地，更是全网吃瓜文化的风向标，让每一位用户都能在这里找到属于自己的吃瓜乐趣。",
  stats: [
    { label: "每日更新", value: "200+条" },
    { label: "覆盖明星", value: "500+位" },
    { label: "忠实用户", value: "超千万" },
  ],
  image: "https://readdy.ai/api/search-image?query=Modern%20minimalist%20digital%20newsroom%20workspace%20with%20multiple%20screens%20showing%20entertainment%20news%20headlines%2C%20warm%20amber%20lighting%2C%20clean%20editorial%20aesthetic%2C%20professional%20yet%20casual%20atmosphere%2C%20dark%20wood%20desk%20with%20coffee%20cup%2C%20soft%20bokeh%20background%2C%20magazine%20editorial%20quality%2C%20warm%20color%20palette%20with%20deep%20crimson%20accents&width=800&height=500&seq=about-platform-2026&orientation=landscape",
};

export const appData = {
  title: "随时随地，吃瓜不停",
  subtitle: "下载51吃瓜App，第一时间获取最新爆料推送",
  description:
    "51吃瓜网移动端App已全面上线，支持iOS与Android双平台。实时推送热门爆料通知，个性化订阅你关注的明星动态，离线阅读省流量，夜间模式护眼舒适。更有独家App专属内容，让你走在吃瓜最前线。",
  features: ["实时推送", "个性订阅", "离线阅读", "夜间模式", "独家内容"],
  qrImage: "https://readdy.ai/api/search-image?query=Minimalist%20QR%20code%20design%20with%20warm%20gradient%20crimson%20and%20amber%20accents%2C%20clean%20modern%20smartphone%20app%20download%20screen%20mockup%2C%20dark%20theme%20with%20warm%20highlights%2C%20mobile%20app%20interface%20showing%20news%20feed%20layout%2C%20editorial%20tech%20aesthetic%2C%20soft%20glow%20effects&width=400&height=400&seq=app-qr-2026&orientation=squarish",
  phoneImage: "https://readdy.ai/api/search-image?query=Elegant%20smartphone%20mockup%20displaying%20a%20modern%20dark-themed%20entertainment%20news%20app%20interface%20with%20trending%20gossip%20headlines%20and%20warm%20crimson%20accent%20design%2C%20floating%20on%20soft%20gradient%20background%2C%20clean%20product%20photography%20style%2C%20premium%20app%20presentation%2C%20no%20text%20on%20background&width=500&height=700&seq=app-phone-2026&orientation=portrait",
};

export const cardsData = [
  {
    id: 1,
    title: "某流量小生片场耍大牌，全组停工等其3小时",
    excerpt: "据现场工作人员爆料，该艺人不仅迟到成性，还对剧组人员颐指气使，引发全组不满...",
    category: "明星黑料",
    time: "2小时前",
    views: "156万",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20film%20set%20with%20empty%20director%20chair%20and%20scattered%20equipment%20under%20dramatic%20warm%20lighting%2C%20tension-filled%20atmosphere%2C%20dark%20moody%20cinematography%2C%20professional%20movie%20production%20scene%2C%20warm%20amber%20and%20crimson%20color%20grading%2C%20editorial%20photography%20quality&width=600&height=400&seq=card-01-2026&orientation=landscape",
  },
  {
    id: 2,
    title: "网红主播偷税被查，涉案金额或达数千万",
    excerpt: "税务部门近日对多位头部网红展开调查，其中某知名主播涉嫌通过多种手段偷逃税款，金额惊人...",
    category: "网红塌房",
    time: "5小时前",
    views: "203万",
    image: "https://readdy.ai/api/search-image?query=Abstract%20representation%20of%20financial%20investigation%20with%20documents%20and%20calculator%20on%20dark%20desk%2C%20warm%20dramatic%20lighting%20with%20shadows%2C%20business%20crime%20concept%2C%20minimalist%20composition%2C%20deep%20crimson%20and%20dark%20amber%20tones%2C%20editorial%20quality&width=600&height=400&seq=card-02-2026&orientation=landscape",
  },
  {
    id: 3,
    title: "某女团成员与经纪人暧昧聊天记录遭泄露",
    excerpt: "一份据称来自某当红女团成员与经纪人的私密聊天记录在网上疯传，内容尺度之大令人咋舌...",
    category: "偶像塌房",
    time: "8小时前",
    views: "341万",
    image: "https://readdy.ai/api/search-image?query=Smartphone%20screen%20displaying%20blurred%20chat%20messages%20on%20dark%20surface%2C%20mysterious%20atmosphere%20with%20soft%20glow%2C%20privacy%20breach%20concept%2C%20warm%20crimson%20lighting%2C%20modern%20tech%20noir%20aesthetic%2C%20clean%20minimal%20composition&width=600&height=400&seq=card-03-2026&orientation=landscape",
  },
  {
    id: 4,
    title: "综艺节目恶意剪辑引众怒，嘉宾集体发声维权",
    excerpt: "某热门综艺因恶意剪辑导致多位嘉宾形象受损，嘉宾联合发表声明要求节目组公开道歉并下架相关片段...",
    category: "综艺内幕",
    time: "12小时前",
    views: "198万",
    image: "https://readdy.ai/api/search-image?query=Professional%20video%20editing%20suite%20with%20timeline%20display%20showing%20entertainment%20content%2C%20dark%20studio%20environment%2C%20dramatic%20warm%20lighting%2C%20media%20production%20concept%2C%20crimson%20and%20amber%20color%20scheme%2C%20editorial%20photography&width=600&height=400&seq=card-04-2026&orientation=landscape",
  },
  {
    id: 5,
    title: "某影帝被曝与多名女演员有不正当关系",
    excerpt: "圈内知情人士向51吃瓜网独家爆料，某德高望重的影帝私下作风混乱，涉及多位知名女星...",
    category: "明星黑料",
    time: "1天前",
    views: "567万",
    image: "https://readdy.ai/api/search-image?query=Dramatic%20film%20noir%20scene%20with%20silhouette%20of%20person%20behind%20frosted%20glass%2C%20mysterious%20atmosphere%2C%20warm%20amber%20light%20streaming%20through%20windows%2C%20Hollywood%20glamour%20meets%20dark%20secrets%20aesthetic%2C%20deep%20crimson%20accents%2C%20cinematic%20composition&width=600&height=400&seq=card-05-2026&orientation=landscape",
  },
  {
    id: 6,
    title: "音乐节主办方拖欠艺人出场费，多名歌手联合讨薪",
    excerpt: "某大型音乐节结束后，多位参演歌手在社交平台集体发声，称主办方至今未支付演出费用，涉及金额超千万...",
    category: "行业黑幕",
    time: "1天前",
    views: "134万",
    image: "https://readdy.ai/api/search-image?query=Empty%20concert%20stage%20after%20music%20festival%20with%20scattered%20equipment%20and%20dim%20lighting%2C%20melancholic%20atmosphere%2C%20warm%20spotlights%20fading%2C%20music%20industry%20concept%2C%20crimson%20and%20amber%20tones%2C%20editorial%20quality%20photography&width=600&height=400&seq=card-06-2026&orientation=landscape",
  },
  {
    id: 7,
    title: "某短视频平台头部博主涉嫌虚假宣传被立案",
    excerpt: "市场监管部门已对多位推广问题产品的短视频博主展开调查，部分博主粉丝量超千万，影响范围极广...",
    category: "网红黑料",
    time: "2天前",
    views: "289万",
    image: "https://readdy.ai/api/search-image?query=Smartphone%20displaying%20social%20media%20live%20streaming%20interface%20on%20dark%20surface%2C%20modern%20digital%20creator%20concept%2C%20warm%20dramatic%20lighting%2C%20tech%20noir%20aesthetic%2C%20deep%20crimson%20glow%2C%20minimalist%20editorial%20composition&width=600&height=400&seq=card-07-2026&orientation=landscape",
  },
];

export const indexData = [
  {
    id: 1,
    title: "明星情感追踪",
    description: "恋爱、分手、结婚、出轨全收录",
    count: 128,
    icon: "ri-heart-pulse-line",
    color: "primary",
  },
  {
    id: 2,
    title: "综艺节目内幕",
    description: "剪辑黑幕、剧本泄露、嘉宾冲突",
    count: 96,
    icon: "ri-tv-2-line",
    color: "accent",
  },
  {
    id: 3,
    title: "影视圈黑料",
    description: "选角潜规则、片酬纠纷、剧组乱象",
    count: 87,
    icon: "ri-film-line",
    color: "primary",
  },
  {
    id: 4,
    title: "网红塌房实录",
    description: "偷税、假货、人设崩塌全纪录",
    count: 112,
    icon: "ri-user-star-line",
    color: "accent",
  },
  {
    id: 5,
    title: "选秀造假揭秘",
    description: "票数造假、内定选手、导师黑幕",
    count: 54,
    icon: "ri-music-2-line",
    color: "primary",
  },
  {
    id: 6,
    title: "代言翻车合集",
    description: "品牌解约、虚假宣传、明星带货",
    count: 73,
    icon: "ri-shopping-bag-3-line",
    color: "accent",
  },
  {
    id: 7,
    title: "娱乐圈法律纠纷",
    description: "官司、合同、版权争议深度解析",
    count: 45,
    icon: "ri-scales-3-line",
    color: "primary",
  },
  {
    id: 8,
    title: "粉丝圈内乱象",
    description: "集资跑路、饭圈互撕、站姐黑幕",
    count: 68,
    icon: "ri-group-2-line",
    color: "accent",
  },
  {
    id: 9,
    title: "每日吃瓜快讯",
    description: "24小时滚动更新的最新爆料汇总",
    count: "每日更新",
    icon: "ri-flashlight-line",
    color: "primary",
  },
];

export const commentsData = [
  {
    id: 1,
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20person%2C%20warm%20studio%20lighting%2C%20neutral%20background%2C%20clean%20minimalist%20style%2C%20friendly%20expression&width=100&height=100&seq=avatar-01-2026&orientation=squarish",
    nickname: "资深吃瓜人",
    time: "3小时前",
    content:
      "这个平台更新速度真的快！比其他家都早半天，每天早上第一件事就是打开51吃瓜看今天的爆料，已经养成习惯了。",
    likes: 2341,
  },
  {
    id: 2,
    avatar: "https://readdy.ai/api/search-image?query=Casual%20portrait%20of%20young%20adult%2C%20warm%20natural%20light%2C%20soft%20background%20blur%2C%20relaxed%20friendly%20vibe%2C%20modern%20editorial%20style&width=100&height=100&seq=avatar-02-2026&orientation=squarish",
    nickname: "八卦小能手",
    time: "昨天",
    content:
      "51吃瓜的黑料深度解析栏目做得太好了，不是简单的标题党，每篇都有时间线和证据梳理，吃瓜吃得明明白白。",
    likes: 1876,
  },
  {
    id: 3,
    avatar: "https://readdy.ai/api/search-image?query=Warm%20portrait%20photography%20of%20person%20with%20genuine%20smile%2C%20soft%20golden%20hour%20lighting%2C%20clean%20background%2C%20natural%20authentic%20look%2C%20editorial%20quality&width=100&height=100&seq=avatar-03-2026&orientation=squarish",
    nickname: "娱乐圈老炮",
    time: "2天前",
    content:
      "从业二十年，这个平台的爆料准确率在业内算很高的，不像某些营销号整天胡编乱造。值得推荐给真正想了解娱乐圈的朋友。",
    likes: 3290,
  },
];

export const contactData = {
  title: "爆料投稿",
  subtitle: "你有猛料？欢迎向我们投稿",
  description:
    "51吃瓜网开放爆料投稿通道，欢迎圈内人士、热心网友提供真实可靠的爆料线索。我们承诺对投稿人信息严格保密，一经采用将给予丰厚稿酬。你的每一次爆料，都是在为吃瓜群众挖掘真相。",
  channels: [
    { icon: "ri-mail-line", label: "投稿邮箱", value: "tips@51chigua.com" },
    { icon: "ri-wechat-line", label: "微信投稿", value: "51chigua_tips" },
    { icon: "ri-phone-line", label: "爆料热线", value: "400-051-5151" },
  ],
};

export const carouselData = [
  {
    id: 1,
    title: "年度重磅：某顶流偶像团体解散内幕大揭秘",
    excerpt:
      "从成员矛盾到公司决策，51吃瓜网独家还原这场震动娱乐圈的解散风波背后的完整真相，涉及多方利益博弈和不为人知的内情。",
    tag: "深度专题",
    image: "https://readdy.ai/api/search-image?query=Dramatic%20stage%20spotlight%20splitting%20into%20multiple%20beams%20on%20dark%20empty%20concert%20stage%2C%20symbolizing%20group%20disbanding%2C%20warm%20crimson%20and%20amber%20lighting%2C%20cinematic%20composition%2C%20emotional%20atmosphere%2C%20editorial%20photography%20quality%2C%20no%20text&width=1000&height=560&seq=carousel-01-2026&orientation=landscape",
  },
  {
    id: 2,
    title: "娱乐圈资本局：谁在背后操控你看到的八卦",
    excerpt:
      "深入调查娱乐公司与营销号的利益链条，揭秘热搜买榜、黑稿产业链、水军运营等灰色地带，还原一个真实的流量江湖。",
    tag: "行业深挖",
    image: "https://readdy.ai/api/search-image?query=Abstract%20chess%20board%20with%20golden%20and%20dark%20pieces%20representing%20power%20dynamics%2C%20warm%20dramatic%20lighting%20from%20above%2C%20corporate%20intrigue%20concept%2C%20dark%20luxurious%20aesthetic%2C%20crimson%20and%20amber%20accents%2C%20editorial%20quality&width=1000&height=560&seq=carousel-02-2026&orientation=landscape",
  },
  {
    id: 3,
    title: "网红经济泡沫：从一夜爆红到全民喊打的48小时",
    excerpt:
      "通过三个典型网红塌房案例，剖析当下网红经济中存在的虚假人设、流量造假和粉丝经济泡沫，揭示爆红背后的隐患与风险。",
    tag: "现象分析",
    image: "https://readdy.ai/api/search-image?query=Bursting%20soap%20bubble%20with%20colorful%20reflections%20on%20dark%20background%2C%20symbolizing%20internet%20fame%20collapse%2C%20dramatic%20warm%20lighting%2C%20conceptual%20art%20photography%2C%20crimson%20and%20amber%20color%20scheme%2C%20editorial%20quality%2C%20elegant%20composition&width=1000&height=560&seq=carousel-03-2026&orientation=landscape",
  },
  {
    id: 4,
    title: "选秀十年：那些被节目组操控的青春与梦想",
    excerpt:
      "从初代选秀到如今的偶像养成综艺，51吃瓜网整理了十年来选秀节目中曝光的内定、造假、剥削等黑暗面，见证选秀产业链的变迁。",
    tag: "十年回顾",
    image: "https://readdy.ai/api/search-image?query=Row%20of%20empty%20audition%20chairs%20under%20dramatic%20spotlights%20on%20dark%20stage%2C%20nostalgic%20yet%20melancholic%20atmosphere%2C%20talent%20show%20concept%2C%20warm%20crimson%20and%20amber%20lighting%2C%20cinematic%20composition%2C%20editorial%20quality&width=1000&height=560&seq=carousel-04-2026&orientation=landscape",
  },
];

export const faqData = [
  {
    id: 1,
    question: "51吃瓜网的爆料内容可靠吗？",
    answer:
      "51吃瓜网的每条爆料内容均经过专业编辑团队多源交叉验证，确保信息真实可靠后再发布。我们坚持「没有证据不爆料」的原则，不会为了流量编造虚假信息，并在每篇稿件中标注信息来源和可信度评级。",
  },
  {
    id: 2,
    question: "如何在51吃瓜网投稿爆料？",
    answer:
      "您可以通过页面底部的爆料投稿通道提交爆料内容，支持邮箱、微信和电话三种方式。我们的编辑团队会在24小时内完成审核，如被采纳将给予相应稿酬。请确保所提供的信息真实有效，我们严格保护投稿人隐私。",
  },
  {
    id: 3,
    question: "51吃瓜网每日更新频率如何？",
    answer:
      "51吃瓜网实行7×24小时滚动更新机制，每日新增爆料内容超过200条。重大事件发生后，编辑团队将在15分钟内发布快讯，30分钟内完成深度追踪报道，确保用户第一时间获取最新资讯。",
  },
  {
    id: 4,
    question: "51吃瓜网App有哪些特色功能？",
    answer:
      "51吃瓜App支持个性化订阅、实时推送通知、离线阅读、夜间护眼模式等功能。更有App独家的深度专题和多媒体内容，流畅的阅读体验让你随时随地享受吃瓜乐趣。搜索「51吃瓜」即可在应用商店下载。",
  },
  {
    id: 5,
    question: "如何辨别真假爆料信息？",
    answer:
      "51吃瓜网每篇爆料稿件都设有「可信度指数」标识，分为「实锤」「高度可信」「持续追踪」「仅供参考」四级。读者可通过这一指标快速判断信息可靠程度。同时，我们建议用户交叉比对多个信息源，理性吃瓜。",
  },
  {
    id: 6,
    question: "51吃瓜网会删除已发布的爆料吗？",
    answer:
      "如爆料内容经证实存在事实错误，51吃瓜网将第一时间发布更正声明并对原文进行标注说明，但保留原文供读者查阅。若涉及当事人合法权益受到侵害，经法律程序确认后将依法处理。我们始终坚持信息公开透明原则。",
  },
];

export const updatesData = [
  {
    id: 1,
    time: "10分钟前",
    title: "某知名歌手突发声明宣布退出娱乐圈，原因令人唏嘘",
    tag: "突发",
  },
  {
    id: 2,
    time: "32分钟前",
    title: "热门网剧男主被曝片场与女配暧昧，工作人员证实",
    tag: "独家",
  },
  {
    id: 3,
    time: "1小时前",
    title: "某综艺嘉宾因不当言论被紧急删减镜头，节目组道歉",
    tag: "热",
  },
  {
    id: 4,
    time: "2小时前",
    title: "知名导演新片票房惨败，投资方集体撤资内幕流出",
    tag: "新料",
  },
  {
    id: 5,
    time: "3小时前",
    title: "某流量小花被拍到与神秘男子同游日本，疑似恋情曝光",
    tag: "今日爆",
  },
  {
    id: 6,
    time: "5小时前",
    title: "音乐平台被曝数据造假，多位歌手真实播放量被严重夸大",
    tag: "实锤",
  },
  {
    id: 7,
    time: "7小时前",
    title: "某知名主持人在直播中出现重大口误，场面一度失控",
    tag: "热",
  },
  {
    id: 8,
    time: "9小时前",
    title: "娱乐公司内部邮件泄露，旗下艺人合约条款引发争议",
    tag: "深扒",
  },
];

export const topicsData = [
  { id: 1, name: "明星塌房", count: "236", hot: true },
  { id: 2, name: "综艺黑幕", count: "189", hot: true },
  { id: 3, name: "网红翻车", count: "167", hot: true },
  { id: 4, name: "选秀造假", count: "142", hot: false },
  { id: 5, name: "代言解约", count: "128", hot: false },
  { id: 6, name: "影视潜规则", count: "115", hot: false },
  { id: 7, name: "饭圈乱象", count: "103", hot: false },
  { id: 8, name: "明星税务", count: "97", hot: true },
  { id: 9, name: "剧组纠纷", count: "88", hot: false },
  { id: 10, name: "恋情曝光", count: "76", hot: false },
  { id: 11, name: "直播乱象", count: "65", hot: false },
];

export const featuresData = [
  {
    id: 1,
    title: "极速追踪，全天候更新",
    description:
      "7×24小时不间断滚动更新，重大事件15分钟内出快讯。编辑团队遍布全国，确保热点发生第一时间同步至平台。",
    icon: "ri-rocket-2-line",
    color: "primary",
  },
  {
    id: 2,
    title: "深度挖掘，还原真相",
    description:
      "不止于表面消息，每一条爆料都附完整时间线与关系梳理。专业记者多源交叉验证，让你吃得明明白白。",
    icon: "ri-search-eye-line",
    color: "accent",
  },
  {
    id: 3,
    title: "严格把关，拒绝谣言",
    description:
      "每条内容均标注「可信度指数」，坚决抵制虚假爆料。保护当事人合法权益的同时，捍卫公众知情权。",
    icon: "ri-shield-check-line",
    color: "primary",
  },
];

export const mediaData = [
  {
    id: 1,
    title: "独家专访：业内人士亲述选秀节目暗箱操作全过程",
    duration: "18:24",
    views: "89万",
    image: "https://readdy.ai/api/search-image?query=Professional%20interview%20setup%20with%20silhouetted%20figure%20in%20dim%20studio%20lighting%2C%20documentary%20style%2C%20warm%20dramatic%20atmosphere%2C%20investigative%20journalism%20concept%2C%20crimson%20and%20amber%20tones%2C%20cinematic%20composition&width=600&height=340&seq=media-01-2026&orientation=landscape",
  },
  {
    id: 2,
    title: "重磅揭秘：娱乐圈水军产业链运作内幕全曝光",
    duration: "22:36",
    views: "156万",
    image: "https://readdy.ai/api/search-image?query=Rows%20of%20smartphones%20on%20dark%20desk%20with%20glowing%20screens%2C%20organized%20tech%20operation%20concept%2C%20cyber%20investigation%20aesthetic%2C%20warm%20amber%20glow%20from%20screens%2C%20dark%20atmospheric%20lighting%2C%20editorial%20quality&width=600&height=340&seq=media-02-2026&orientation=landscape",
  },
  {
    id: 3,
    title: "深度追踪：某顶流明星塌房事件完整时间线复盘",
    duration: "31:15",
    views: "234万",
    image: "https://readdy.ai/api/search-image?query=Timeline%20visualization%20with%20connected%20nodes%20on%20dark%20background%2C%20investigation%20board%20aesthetic%2C%20detective%20concept%2C%20warm%20crimson%20and%20amber%20connecting%20lines%2C%20professional%20data%20visualization%20style%2C%20editorial%20composition&width=600&height=340&seq=media-03-2026&orientation=landscape",
  },
  {
    id: 4,
    title: "现场直击：粉丝接机混乱场面背后的利益链条",
    duration: "15:42",
    views: "67万",
    image: "https://readdy.ai/api/search-image?query=Crowded%20airport%20arrival%20area%20with%20blurred%20motion%20of%20people%20under%20warm%20terminal%20lighting%2C%20fan%20culture%20concept%2C%20documentary%20style%20photography%2C%20crimson%20and%20amber%20tones%2C%20editorial%20quality%2C%20atmospheric&width=600&height=340&seq=media-04-2026&orientation=landscape",
  },
  {
    id: 5,
    title: "幕后分析：综艺节目如何通过剪辑操控观众情绪",
    duration: "26:08",
    views: "112万",
    image: "https://readdy.ai/api/search-image?query=Professional%20video%20editing%20workstation%20with%20multiple%20displays%20showing%20timeline%20in%20dark%20studio%2C%20media%20manipulation%20concept%2C%20warm%20glow%20from%20screens%2C%20documentary%20aesthetic%2C%20crimson%20and%20amber%20accents&width=600&height=340&seq=media-05-2026&orientation=landscape",
  },
];

export const footerData = {
  description:
    "51吃瓜网入口——全网最热吃瓜爆料平台，每日更新海量娱乐圈黑料、明星八卦与综艺内幕。我们以快速、准确、深度为核心理念，为千万吃瓜群众提供最优质的娱乐资讯服务，让每一次吃瓜都物超所值。",
  sections: [
    {
      title: "热门专题",
      links: [
        { name: "实时快讯", href: "#updates" },
        { name: "专题合集", href: "#index" },
        { name: "热门话题", href: "#topics" },
        { name: "深度专题", href: "#carousel" },
        { name: "常见问答", href: "#faq" },
      ],
    },
    {
      title: "关于平台",
      links: [
        { name: "关于我们", href: "#about" },
        { name: "平台特色", href: "#features" },
        { name: "爆料投稿", href: "#contact" },
        { name: "下载App", href: "#app" },
        { name: "热度排行", href: "#ranking" },
      ],
    },
  ],
};